import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SpaceContext = createContext(null);
const LS_KEY = "vault_active_space";

export function SpaceProvider({ children }) {
  const { user } = useAuth();
  const [spaces, setSpaces] = useState([]);
  const [activeSpaceId, setActiveSpaceIdState] = useState(localStorage.getItem(LS_KEY) || "");
  const [loading, setLoading] = useState(true);

  const setActiveSpaceId = (id) => {
    setActiveSpaceIdState(id || "");
    if (id) localStorage.setItem(LS_KEY, id);
    else localStorage.removeItem(LS_KEY);
  };

  const reload = async () => {
    try {
      const { data } = await api.get("/spaces");
      setSpaces(data);
      setActiveSpaceIdState((cur) => {
        if (cur && data.some((s) => s.id === cur)) return cur;
        const general = data.find((s) => s.is_general);
        const next = (general || data[0])?.id || "";
        if (next) localStorage.setItem(LS_KEY, next);
        return next;
      });
      return data;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && typeof user === "object") { reload(); }
    else { setSpaces([]); setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user && user.id]);

  const activeSpace = spaces.find((s) => s.id === activeSpaceId) || null;

  return (
    <SpaceContext.Provider value={{ spaces, activeSpaceId, activeSpace, setActiveSpaceId, reload, loading }}>
      {children}
    </SpaceContext.Provider>
  );
}

export const useSpaces = () => useContext(SpaceContext);
